module.exports = __webpack_public_path__ + "static/media/2pic.1bbffd72.png";